import { Grid, Typography, Box } from "@mui/material";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

const LandingPage: React.FC = () => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "background.default",
            }}
        >
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid item>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <DescriptionRoundedIcon
                            sx={{
                                fontSize: 56,
                                color: "primary.main",
                                mb: 1,
                                animation: "rotateYPause 1.6s cubic-bezier(0.4,0,0.2,1) infinite"
                            }}
                        />
                        <Typography variant="h5" sx={{ fontWeight: 600 }}>
                            Configuring your application...
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Please wait while we prepare your Docutech environment.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LandingPage;